//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import logger from "@/utils/logger";

export default {
  name: "StockValueTableWidget",
  props: {
    searchQuery: {
      type: String,
      default: ""
    },
  selectedDate: {
    type: String,
    default: null
  },
   selectedWarehouse: {
    type: Number,
    default: null
  } 
  },
  data() {
    return {
      items: [],
      loading: false,
      pagination: {
        page: 1,
        rowsPerPage: 10,
        sortBy: "ProductNumber",
        descending: false,
        rowsNumber: 0
      },
      columns: [
        {
          name: "ProductNumber",
          align: "left",
          label: this.$t("stock.productNo"),
          field: "productNumber",
          style: "width: 300px",
          sortable: true
        },
        {
          name: "ProductName",
          align: "left",
          label: this.$t("stock.productName"),
          field: "productName",
          sortable: true
        },
        {
          name: "ItemsInStock",
          align: "right",
          label: this.$t("common.quantity"),
          style: "width:90px",
          field: "itemsInStock",
          sortable: false
        },
        {
          name: "CostPrice",
          align: "right",
          label: this.$t("products.costPrice"),
          style: "width:90px",
          field: "costPrice",
          sortable: true
        },
        {
          name: "StockValue",
          align: "right",
          label: this.$t("stock.sumStockValue"),
          style: "width:90px",
          field: "stockValue",
          sortable: false
        },
        {
          name: "WeightedAverageCostPrice",
          align: "right",
          label: this.$t("products.weightedAverageCostPrice"),
          style: "width:90px",
          field: "weightedAverageCostPrice",
          sortable: true
        },
        {
          name: "StockValueWeightedPrice",
          align: "right",
          label: this.$t("stock.sumStockValueWeightedPrice"),
          style: "width:90px",
          field: "stockValueWeightedPrice",
          sortable: false
        }
      ],
      fetchDataTimeout: null,
      debounceTimer: null
    };
  },
  watch: {
    searchQuery: {
      handler: "onSearchQueryChange"
    },
    
  selectedDate: {
    handler: "onSelectedDateChange"
  },
   selectedWarehouse: {
    handler: "onSelectedWarehouseChange"
  },
    loading(newValue, oldValue) {
      if (newValue != oldValue) {
        this.$emit('update-value', newValue)
      }
    },
  },
  methods: {
    ...mapActions("main", ["getStockValue"]),
    getColValue(col) {
      if (col.field === "productNumber") return col.value;
      if (!this.isNumeric(col.value)) return col.value;
      
      return new Intl.NumberFormat("no-NO", {
        minimumFractionDigits: 2,
      }).format(col.value);
    },
    isNumeric(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    },
    getSortOrder(col) {
      if (col.sortable && col.name === this.pagination.sortBy) {
        return this.pagination.descending ? "desc" : "asc";
      }
      return null;
    },
    onRequest(params) {
      if (this.loading) return;
      Object.assign(this.pagination, params.pagination);
      this.fetchData();
    },
    onSort(col) {
      if (this.loading) return;
      if (col.sortable) {
        if (this.pagination.sortBy === col.name) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = col.name;
          this.pagination.descending = false;
          this.pagination.page = 1;
        }
        this.fetchData();
      }
    },

onSelectedWarehouseChange() {
       this.pagination.page = 1;
        this.fetchData();
    },

    onSelectedDateChange() {
       this.pagination.page = 1;
        this.fetchData();
    },
    onSearchQueryChange() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(() => {
        this.pagination.page = 1;
        this.fetchData();
      }, 1500);
    },
    onRowClick(evt, row) {
      this.$emit("row-click", row);
    },
    debounceFetch() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.pagination.page = 1;
        this.fetchData();
      }, 500);
    },
    fetchData() {
      clearTimeout(this.fetchDataTimeout);
      this.fetchDataTimeout = setTimeout(async () => {
        if (this.loading) return;
        this.loading = true;

        let { sortBy, descending } = this.pagination;
        const colDef = this.columns.find(c => c.name === sortBy && c.sortable);
        if (!colDef) {
          sortBy = "ProductNumber";
          descending = false;
          Object.assign(this.pagination, { sortBy, descending });
        }

        const params = {
          pageNumber: this.pagination.page,
          pageSize: this.pagination.rowsPerPage,
          searchQuery: this.searchQuery,
          sortBy,
          sortDescending: descending,
          datetime: this.selectedDate,
          warehouseId: this.selectedWarehouse
        };

        try {
          const res = await this.getStockValue(params);
          this.items = res.items;
          this.pagination.rowsNumber = res.totalCount;
          this.$emit("total-value", res.totalValue);
          this.$emit("total-weighted-value", res.totalWeightedValue);
        }
        catch (err) {
          logger.log("Error loading stock‐value data", err);
          this.$q.notify({ type: "negative", message: this.$t("common.errorFetchingData") });
        }
        finally {
          this.loading = false;
        }
      }, 200);
    },
    refresh() {
      this.fetchData();
    }
  },

  mounted() {
    this.fetchData();
  },

  beforeDestroy() {
    clearTimeout(this.fetchDataTimeout);
    clearTimeout(this.debounceTimer);
  }
};
